<ng-container *ngIf="model; else elseTemplate">
  <div class="text-center">
    <h1 class="display-1">Congratulations {{ model.businessName }}!</h1>
    <p class="lead">You are one step away from receiving lifetime earnings!</p>

    <blockquote class="blockquote">
      <p class="mb-0">
        Thank you for your patience. It will take 3 to 5 banking days to totally
        activate your account.
      </p>
      <footer class="blockquote-footer">
        Yours truly, <cite title="Source Title">PayRetail</cite>
      </footer>
    </blockquote>
  </div>
</ng-container>
<ng-template #elseTemplate>
  <div class="text-center">
    <div class="error mx-auto" data-text="404">404</div>
    <p class="lead text-gray-800 mb-5">Page Not Found</p>
    <p class="text-gray-500 mb-0">
      It looks like you found a glitch in the matrix...
    </p>
  </div>
</ng-template>
